import { useMemo } from "react";
import { Section } from "views/applications-id-report/components/Section";
import { CombinedIncome } from "../../types/income";
import {
  mapIncomeSourceStatus,
  mapUnverifiedIncomeStatus
} from "../../helpers";
import { IncomeType } from "shared/types";
import { IncomeSourceWarning } from "./components/IncomeSourceWarning";

export const DocumentWarnings = ({
  incomes
}: {
  incomes: CombinedIncome[];
}) => {
  const incomeSourceItems = useMemo(
    () =>
      incomes
        .map((inc) => mapIncomeSourceStatus(inc))
        .filter(
          (incSource) =>
            incSource.status && incSource.type !== IncomeType.HousingAssistance
        ),
    [incomes]
  );
  const incomeSourceWarnings = incomeSourceItems.filter(
    (incSource) => incSource.status === "Warning"
  );
  const incomeSourceErrors = incomeSourceItems.filter(
    (incSource) => incSource.status === "Rejected"
  );

  const unverifiedIncomeWarnings = incomes
    .filter(
      (income) => income.status === "pending" && Boolean(income.sources?.length)
    )
    .map(mapUnverifiedIncomeStatus);

  const warningsCount =
    incomeSourceWarnings.length +
    incomeSourceErrors.length +
    unverifiedIncomeWarnings.length;
  if (warningsCount === 0) return null;

  return (
    <Section
      sectionTitle="Warnings"
      maxWidth="none"
      sectionClassName="mt-9 mb-10"
    >
      <div className="flex flex-col gap-4">
        {unverifiedIncomeWarnings.map(
          ({ incomeName, incomeId, description, status }) => (
            <IncomeSourceWarning
              key={incomeId}
              incomeId={incomeId}
              incomeName={incomeName}
              statusMessage="could not be verified"
              description={description}
              status={status as "Rejected"}
            />
          )
        )}
        {incomeSourceWarnings.map(
          ({ incomeName, incomeId, description, status }) => (
            <IncomeSourceWarning
              key={incomeId}
              incomeId={incomeId}
              incomeName={incomeName}
              statusMessage="has verification warnings"
              description={description}
              status={status as "Warning"}
            />
          )
        )}
        {incomeSourceErrors.map(
          ({ incomeName, incomeId, description, status }) => (
            <IncomeSourceWarning
              key={incomeId}
              incomeId={incomeId}
              incomeName={incomeName}
              statusMessage="has verification warnings"
              description={description}
              status={status as "Rejected"}
            />
          )
        )}
      </div>
    </Section>
  );
};
